    angular.module('qkr').controller('MenuItemEditController',
        ($scope, $rootScope, $uibModalInstance, $sce, prod,  isNewProduct, menu,
         permissionTemplateList, variantService, FormHelper, utils, $uibModal, merchantService,
         menuService, messageService, gettextCatalog, notificationService, appConfig, APP_CONSTANT,
         departmentService, pushNotificationService, pushNotificationContext, _) => {
        const vm = $scope;
        const formHelper = new FormHelper($scope);


        vm.newProduct = isNewProduct;
        vm.currentProduct = prod;
        const variantInfrastructure = variantService.getVariantInfrastructure(vm.currentProduct.variants, 3);
        vm.currentProduct.variants = variantService.getVariantsFromInfrastructure(variantInfrastructure);
        const DAY_OF_WEEK_OFFSET =1;
        vm.currentMenu = menu;
        vm.display = {};
        vm.form = angular.copy(vm.currentProduct);
        vm.holder = {};
        vm.holder.customizationsExpanded = true;
        vm.holder.availabilityExpanded = false;
        vm.holder.menuAlwaysAvailable = false;
        vm.notification = {};
        vm.notification.enabled = false;
        vm.notification.originalEmailAddresses = [];
        vm.notification.shownEmailAddresses = [];
        vm.notification.newNotificationEmail;
        vm.hours = menuService.getHours();
        vm.minutes = menuService.getMinutes();
        vm.daysOfWeek = menuService.getDaysOfWeek();
        vm.daysOfMonth = menuService.getDaysOfMonth();
        vm.showClass = false;
        vm.permissionScreen = 0;
        vm.currentTemplate = null;
        vm.canEditPermissionForm = true;
        vm.hasSetForm = false;
        vm.showQuestFields = ($rootScope.merchantInfo.showQuest);

        if (prod.form) {
            vm.currentTemplate = angular.copy(prod.form);
            vm.hasSetForm = true;
        }

        vm.permissionFormEnabled = (vm.currentTemplate != null);
        vm.permissionTemplateList = permissionTemplateList;

        // An array that represents the list of days - with associated variables for
        // Disabling/selecting
        vm.days = utils.getDaysOfWeekWithSelected();

        angular.forEach(vm.days, (day) => {
            day.enabled = true;
        });

        if (vm.form == null) {
            vm.form = {};
        }

        vm.messageTypes = [
            {type: 'EMAIL', display: gettextCatalog.getString('Immediately')},
            {type: 'DAILY_EMAIL', display: gettextCatalog.getString('Daily')},
            {type: 'WEEKLY_EMAIL', display: gettextCatalog.getString('Weekly')},
            {type: 'MONTHLY_EMAIL', display: gettextCatalog.getString('Monthly')}
        ];

        vm.notification.whenToSend = vm.messageTypes[0].display;


        notificationService.getNotificationsForProduct(vm.currentProduct).then((promise) => {
            vm.notification.messageType = 'EMAIL'; // Default


            $.each(promise.data, (index, value) => {
                // If any are enabled, then consider all enabled
                if (value.enabled) {
                    vm.notification.enabled = true;
                }

                if(value.sendDayOfWeek){
                    vm.notificationDay = vm.daysOfWeek[value.sendDayOfWeek-DAY_OF_WEEK_OFFSET];
                }
                vm.notification.originalEmailAddresses.push(value.recipient);
                vm.notification.shownEmailAddresses.push(value.recipient);
                vm.notification.messageType = value.messageType;
                vm.notification.hour = value.sendHour;
                vm.notification.minute = value.sendMinute;
                vm.notification.dayOfWeek = vm.notificationDay.name;
                vm.notification.dayOfMonth = value.sendDayOfMonth;
            });
        });

        vm.optionSets = vm.form.optionSets;

        vm.addNotificationEmailAddress = function() {
            vm.errorsNotificationEmail = {};
            const emailAddress = vm.notification.newNotificationEmail;
            if (!utils.isEmailValid(emailAddress)) {
                vm.errorsNotificationEmail.hasEmail = gettextCatalog
                    .getString('Please enter a valid email address');
            }
        };

        vm.removeOptionSet = function(index) {
            vm.form.optionSets[index].disabled = !vm.form.optionSets[index].disabled;
        };

        vm.isSchoolLike = function() {
            return merchantService.behaviour($rootScope.merchantInfo, 'schoolLike');
        };

        vm.removeNotificationEmailAddress = function(emailAddress) {
            const index = vm.notification.shownEmailAddresses.indexOf(emailAddress);
            if (index > -1) {
                vm.notification.shownEmailAddresses.splice(index, 1);
            }
        };

        vm.addNotificationEmailAddress = function() {
            vm.errorsNotificationEmail = {};
            const emailAddress = vm.notification.newNotificationEmail;
            if (!(/^[A-Za-z0-9._%+-]*[A-Za-z0-9]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(emailAddress))) {
                vm.errorsNotificationEmail.hasEmail = gettextCatalog.getString('Please enter a valid email address');
                return;
            }

            const index = vm.notification.shownEmailAddresses.indexOf(emailAddress);
            if (index == -1) {
                vm.notification.shownEmailAddresses.push(emailAddress);
                vm.notification.newNotificationEmail = null;
            }
        };

        vm.style = function (value) {
            return {
                'background-color': '#' + value.colour
            };
        },

            vm.validateForm = function() {
                vm.errors = null;
                let valid = true;
                const errors = {};
                if (utils.hasNoValue(vm.uploadableProduct.amountMinorUnits)) {
                    vm.uploadableProduct.amountMinorUnits = 0;
                } else if (vm.uploadableProduct.amountMinorUnits < 0) {
                    errors.amount = gettextCatalog.getString('Amount may not be negative');
                    valid = false;
                }
                if (vm.display.maxQuantity < 0) {
                    errors.maxQuantity = gettextCatalog.getString('Max Quantity may not be negative. Enter a positive value, or 0 for no limit');
                    valid = false;
                }

                if (vm.isSchoolLike() && vm.display.onePerBeneficiary == 1 && !vm.display.purchaseOnceType) {
                    errors.purchaseOnceType = gettextCatalog.getString('Please select a Purchase Once setting');
                    valid = false;
                }

                if (vm.display.menuType == 'fixed') {
                    if ((utils.hasNoValue(vm.display.orderEndDate))) {
                        errors.fixedAvailability = gettextCatalog.getString('Please enter a final order date');
                        valid = false;
                        vm.holder.availabilityExpanded = true;
                    } else if (utils.hasNoValue(vm.display.endDate)) {
                        errors.fixedAvailability = gettextCatalog.getString('Please enter an Order fulfilment date');
                        valid = false;
                        vm.holder.availabilityExpanded = true;
                    } else {
                        const cutoffDateAndTime = utils.serverDateStringtoDate(vm.display.orderEndDate);
                        if (utils.hasNoValue(vm.display.cutOffTime)) {
                            const d = new Date();
                            vm.display.cutOffTime = d;
                        }
                        cutoffDateAndTime.setHours(vm.display.cutOffTime.getHours());
                        cutoffDateAndTime.setMinutes(vm.display.cutOffTime.getMinutes());
                        const endDate = utils.serverDateStringtoDate(vm.display.endDate);
                        endDate.setHours(23);
                        endDate.setMinutes(59);
                        endDate.setSeconds(59);
                        const endCutoffDateAndTime = utils.serverDateStringtoDate(vm.display.endDate);
                        if (vm.currentMenu.availability.cutoffOffsetInMinutes == null) {
                            endCutoffDateAndTime.setHours(23);
                            endCutoffDateAndTime.setMinutes(59);
                            endCutoffDateAndTime.setSeconds(59);
                        } else {
                            endCutoffDateAndTime.setMinutes(endCutoffDateAndTime.getMinutes() + vm.currentMenu.availability.cutoffOffsetInMinutes);
                        }
                        if (cutoffDateAndTime > endDate) {
                            errors.fixedAvailability = gettextCatalog.getString('Final order date cannot be later than fulfilment date');
                            valid = false;
                            vm.holder.availabilityExpanded = true;
                        } else if (cutoffDateAndTime > endCutoffDateAndTime) {
                            errors.fixedAvailability = gettextCatalog.getString('Final order date cannot be later than menu order date');
                            valid = false;
                            vm.holder.availabilityExpanded = true;
                        }
                    }
                }

                if (vm.display.menuType == 'recurring') {
                    // Final date after menu final
                    if (vm.uploadableProduct.availability.expiryDateStr != null) {
                        if (!utils.hasNoValue(vm.currentMenu.availability.expiryDateStr)) {
                            var menuEndDate = utils.serverDateStringtoDate(vm.currentMenu.availability.expiryDateStr);
                            const productEndDate = utils.serverDateStringtoDate(vm.uploadableProduct.availability.expiryDateStr);

                            if (menuEndDate < productEndDate) {
                                errors.endDate = gettextCatalog.getString('The final date cannot be after the menu\'s final date');
                                valid = false;
                            }
                        }
                    }

                    if (!utils.hasNoValue(vm.currentMenu.availability.cutoffOffsetInMinutes)) {
                        // Cutoff time after menu cutoff
                        // If both then both new date
                        // If one then copy
                        let newEndDate;
                        var menuEndDate;

                        if (!utils.hasNoValue(vm.currentMenu.availability.expiryDateStr)) {
                            menuEndDate = utils.serverDateStringtoDate(vm.currentMenu.availability.expiryDateStr);
                            if (!utils.hasNoValue(vm.uploadableProduct.availability.expiryDateStr)) {
                                newEndDate = utils.serverDateStringtoDate(vm.uploadableProduct.availability.expiryDateStr);
                            }

                            if (utils.hasNoValue(newEndDate)) {
                                newEndDate = angular.copy(menuEndDate);
                            }

                            menuEndDate.setMinutes(menuEndDate.getMinutes() + vm.currentMenu.availability.cutoffOffsetInMinutes);
                            newEndDate.setMinutes(newEndDate.getMinutes() + vm.uploadableProduct.availability.cutoffOffsetInMinutes);

                            if (menuEndDate < newEndDate) {
                                errors.cutoff = gettextCatalog.getString('The Product availability \'Final date and time for orders\' cannot be later than the Menu availability \'Final date and time for orders\'');
                                valid = false;
                            }
                        } else if (utils.hasNoValue(vm.uploadableProduct.availability.expiryDateStr)) {
                            const menuCutOffMinutes = vm.currentMenu.availability.cutoffOffsetInMinutes;
                            const itemCutOffMinutes = vm.uploadableProduct.availability.cutoffOffsetInMinutes;
                            if (!utils.hasNoValue(menuCutOffMinutes) && !utils.hasNoValue(itemCutOffMinutes) && (menuCutOffMinutes < itemCutOffMinutes)) {
                                errors.cutoff = gettextCatalog.getString('The cut-off time cannot be after the menu\'s cut-off time');
                                valid = false;
                            }
                        }

                        if (utils.hasNoValue(vm.display.cutOffTime)) {
                            errors.cutoff = gettextCatalog.getString('A cut-off time for orders must be selected');
                            valid = false;
                        }
                    }
                }

                vm.errorsNotificationEmail = {};
                if (vm.notification.enabled) {
                    if (utils.hasNoValue(vm.notification.shownEmailAddresses) || vm.notification.shownEmailAddresses.length < 1) {
                        vm.errorsNotificationEmail.hasEmail = gettextCatalog.getString('Please add at least one email.');
                        valid = false;
                    }
                }

                if (!vm.uploadableProduct.name) {
                    errors.name = gettextCatalog.getString('Please enter a name.');
                    valid = false;
                }

                vm.errors = errors;

                return valid;
            },

            vm.saveMenu = function() {

                if (vm.display.menuType === APP_CONSTANT.MENU_TYPE_FIXED) {
                    if (!vm.validateForm()) {
                        return;
                    }
                    vm.transformForSaving();
                } else {
                    vm.transformForSaving();
                    if (!vm.validateForm()) {
                        return;
                    }
                }
                vm.saving = true;

                vm.uploadableProduct.notificationUpdateCommand = vm.updateNotificationEmailAddresses();

                menuService.updateMenuItem(vm.uploadableProduct).then((response) => {
                    // vm.updateNotificationEmailAddresses()
                    vm.saveMenuCallback(response);
                }, (reason) => {
                    vm.saveMenuCallback(reason);
                });
            },

            // Handle response from attempted save
            vm.saveMenuCallback = function(response) {
                const r = formHelper.handleResponse(response);
                if (r.isSuccess()) {
                    menuService.loadMenuItems().then((menuItemsResponse) => {
                        vm.menuItems = menuItemsResponse;
                        $rootScope.$broadcast('reloadMenuItems', menuItemsResponse);
                        vm.saving = false;

                        $uibModalInstance.close(response.data);
                        messageService.saveAlert();
                    });
                    // Reload the dashboard info
                    $rootScope.$broadcast('reloadDashboard');
                } else {
                    vm.saving = false;
                    vm.errors = {};

                    if (response.data && response.data.errors && response.data.errors.length > 0) {
                        messageService.error(response, null, true);
                    } else {
                        messageService.error(gettextCatalog.getString('A problem was encountered when saving. Please try again.'));
                    }
                }
            },

            // Sets ui specific elements
            vm.transformForRendering = function() {
                if (utils.hasNoValue(vm.currentProduct.availability))
                    vm.currentProduct.availability = {};

                vm.form = angular.copy(vm.currentProduct);
                if (vm.form == null) {
                    vm.form = {};
                }

                // Create the options that the display binds to
                vm.display = angular.copy(vm.form.options);
                if (utils.hasNoValue(vm.display)) {
                    vm.display = {};
                }
                vm.display.showAvailability = true;
                // By default .disabled will not be set on each set
                angular.forEach(vm.form.disabledOptionSets, (d) => {
                    for (let i = 0; i < vm.form.optionSets.length; i++) {
                        if (d.id === vm.form.optionSets[i].id) {
                            vm.form.optionSets[i].disabled = true;
                        }
                    }
                });
                vm.display.menuType = utils.getMenuType(menu);
                if (vm.display.menuType === 'realtime') {
                    vm.display.showAvailability = false;
                } else if (vm.display.menuType === 'fixed') {
                    if (!utils.fixedMenuHasNoAvailability(vm.currentMenu)) {
                        vm.display.menuHasFixedDate = true;
                    }
                }

                if (utils.hasNoValue(vm.display.maxPerBeneficiary) || vm.display.maxPerBeneficiary == 0) {
                    vm.display.onePerBeneficiary = false;
                } else {
                    vm.display.onePerBeneficiary = true;
                }

                vm.menuAvailability = vm.currentMenu.availability;

                vm.holder.itemAlwaysAvailable = vm.itemAlwaysAvailable();

                if (!utils.hasNoValue(vm.form.availability)) {
                    if (!utils.hasNoValue(vm.form.availability.expiryDateStr)) {
                        vm.display.endDate = utils.serverDateStringtoDate(vm.form.availability.expiryDateStr);
                    }
                    // Prepopulate from the menu if not specified on this menuitem
                    if (!utils.hasNoValue(vm.menuAvailability)) {
                        if (!utils.hasNoValue(vm.menuAvailability.expiryDateStr)) {
                            // Only default to menu if none set on menuItem
                            if (utils.hasNoValue(vm.display.endDate)) {
                                vm.display.endDate = utils.serverDateStringtoDate(vm.menuAvailability.expiryDateStr);
                            }
                            // Setup variables to limit down availability
                            vm.display.maxEndDate = utils.serverDateStringtoDate(vm.menuAvailability.expiryDateStr);
                        }
                    }

                    if (!utils.hasNoValue(vm.form.availability.blackoutDates)) {
                        const bdl = vm.form.availability.blackoutDates.split(',');
                        vm.display.blackoutDateList = [];
                        for (var i = 0; i < bdl.length; i++) {
                            const d = utils.serverDateToDate(bdl[i]);

                            vm.display.blackoutDateList.push(d);
                        }
                    }
                    if (!utils.hasNoValue(vm.form.availability.orderDays)) {
                        for (var i = 0; i < vm.days.length; i++) {
                            vm.days[i].selected = vm.form.availability.orderDays.indexOf(vm.days[i].name) != -1;
                        }
                    }

                    if (!utils.hasNoValue(vm.form.availability.cutoffOffsetInMinutes)) {
                        vm.setCutoffTime(vm.form.availability.cutoffOffsetInMinutes);
                    } else {
                        vm.display.cutOffTime = null;
                    }
                }
                // Prepopulate any items from the menu
                if (!utils.hasNoValue(vm.currentMenu.availability)) {
                    const menuAv = vm.currentMenu.availability;

                    if (!utils.hasNoValue(menuAv.orderDays)) {
                        // Only default to menu if none set on menuItem

                        if (utils.hasNoValue(vm.form.availability.orderDays)) {
                            for (var i = 0; i < vm.days.length; i++) {
                                vm.days[i].selected = menuAv.orderDays.indexOf(vm.days[i].name) != -1;
                            }
                        }
                        for (var i = 0; i < vm.days.length; i++) {
                            vm.days[i].enabled = menuAv.orderDays.indexOf(vm.days[i].name) != -1;
                        }
                    } else {
                        // An empty string indicates that all days have been deselected
                        if (menuAv.orderDays === '') {
                            for (var i = 0; i < vm.days.length; i++) {
                                vm.days[i].enabled = false;
                            }
                        }
                    }

                    if (!utils.hasNoValue(menuAv.cutoffOffsetInMinutes) && !utils.hasNoValue(vm.currentProduct.availability)) {
                        // Only default to menu if none set on menuItem

                        if (utils.hasNoValue(vm.currentProduct.availability.cutoffOffsetInMinutes)) {
                            vm.setCutoffTime(menuAv.cutoffOffsetInMinutes);
                        }
                    }
                }
            };

            vm.changeDayEnabled = function(day) {
                if (day.enabled || (!day.enabled && day.selected)) // Allow turning it
                // Off
                // - not on
                    day.selected = !day.selected;
                vm.display.calendar_days_changed = !vm.display.calendar_days_changed;
            };

            vm.setCutoffTime = function(cutoffInMins) {
                const cutoff = cutoffInMins;
                let cutoffhrs = cutoff % 1440;
                const rolloveroffset = cutoffhrs < 0 ? 24 * 60 : 0;
                cutoffhrs = rolloveroffset + cutoffhrs;
                const time_cutoff = cutoffhrs;
                const time_cutoff_hours = Math.floor(time_cutoff / 60);
                const time_cutoff_minutes = time_cutoff % 60;
                const day_start = cutoff - time_cutoff;
                const lead_time = Math.floor(Math.abs(cutoff * 1.0 / 1440.0)) + rolloveroffset / 1440;

                vm.display.leadTime = lead_time;

                if (vm.display.menuType === 'fixed') {
                    if (vm.display.endDate != null) {
                        var orderend = utils.serverDateStringtoDate((vm.display.endDate));

                        orderend.setDate(orderend.getDate() - lead_time);
                        vm.display.orderEndDate = angular.copy(orderend);

                        if (vm.currentMenu.availability.cutoffOffsetInMinutes == cutoffInMins) {
                            vm.display.endCutoffDate = angular.copy(vm.display.orderEndDate);
                        } else {
                            const cutoffEnd = vm.currentMenu.availability.cutoffOffsetInMinutes;
                            let cutoffhrsEnd = cutoffEnd % 1440;
                            const rolloveroffsetEnd = cutoffhrsEnd < 0 ? 24 * 60 : 0;
                            cutoffhrsEnd = rolloveroffsetEnd + cutoffhrsEnd;
                            const time_cutoffEnd = cutoffhrsEnd;
                            const time_cutoff_hoursEnd = Math.floor(time_cutoffEnd / 60);
                            const time_cutoff_minutesEnd = time_cutoffEnd % 60;
                            const day_startEnd = cutoffEnd - time_cutoffEnd;
                            const lead_timeEnd = Math.floor(Math.abs(cutoffEnd * 1.0 / 1440.0)) + rolloveroffsetEnd / 1440;

                            const orderendEnd = utils.serverDateStringtoDate((vm.display.endDate));

                            orderendEnd.setDate(orderendEnd.getDate() - lead_timeEnd);
                            vm.display.endCutoffDate = orderendEnd;
                        }
                    } else if (vm.currentMenu.availability.endDate != null) {
                        var orderend = new Date(vm.currentMenu.availability.endDate);

                        orderend.setDate(orderend.getDate() - lead_time);
                        vm.display.orderEndDate = angular.copy(orderend);
                    }
                    vm.display.orderEndDate = vm.display.orderEndDate * 1;
                }
                const d = new Date();
                d.setHours(time_cutoff_hours);
                d.setMinutes(time_cutoff_minutes);
                vm.display.cutOffTime = d;

                if (cutoffInMins === 0) {
                    vm.display.cutOffTime = null;
                    vm.display.leadTime = null;
                }
            };

        vm.itemAlwaysAvailable = function () {
            if (utils.hasNoValue(vm.currentProduct.availability))
                return true;

            if (!utils.hasNoValue(vm.currentProduct.availability)) {
                const av = angular.copy(vm.currentProduct.availability);

                if (!utils.hasNoValue(av)) {
                    if (!utils.hasNoValue(av.expiryDateStr) || !utils.hasNoValue(av.blackoutDates) || (!utils.hasNoValue(av.orderDays) && av.orderDays.split(',').length != 7))

                        return false;
                }
            }
            return true;
        },

            // Convert the json to the format expected in the server - i.e. add the
            // "isDefault" flag
            vm.transformForSaving = function () {
                const itemToBeUploaded = angular.copy(vm.form);

                itemToBeUploaded.options = {};

                if (!utils.hasNoValue(vm.display.onePerBeneficiary) && vm.display.onePerBeneficiary) {
                    itemToBeUploaded.options.maxPerBeneficiary = 1;
                }
                if (!utils.hasNoValue(vm.display.maxQuantity) && vm.display.maxQuantity > 0) {
                    itemToBeUploaded.options.maxQuantity = vm.display.maxQuantity;
                }

                if (utils.hasNoValue(vm.display.purchaseOnceType) || vm.display.onePerBeneficiary == 0) {
                    itemToBeUploaded.options.purchaseOnceType = null;
                } else if (!utils.hasNoValue(vm.display.purchaseOnceType)) {
                    itemToBeUploaded.options.purchaseOnceType = vm.display.purchaseOnceType;
                }

                // By default .disabled will not be set on each set
                itemToBeUploaded.disabledOptionSets = [];
                angular.forEach(vm.form.optionSets, (o) => {
                    if (o.disabled) {
                        itemToBeUploaded.disabledOptionSets.push(o);
                    }
                });

                if (!utils.hasNoValue(vm.display)) {
                    if (vm.display.menuType == 'fixed') {
                        if (!utils.hasNoValue(vm.display.endDate))
                            itemToBeUploaded.availability.expiryDateStr = utils.dateToServerDateString(vm.display.endDate);

                        if (!utils.hasNoValue(vm.display.orderEndDate)) {
                            const oneDay = 24 * 60; // Hours*minutes*seconds*milliseconds
                            const oneDayMilliseconds = oneDay * 60 * 1000;

                            const firstDate = utils.serverDateStringtoDate(vm.display.endDate);
                            const secondDate = utils.serverDateStringtoDate(vm.display.orderEndDate);

                            const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDayMilliseconds)));
                            var leadTime = parseInt(diffDays) * 24 * 60;

                            if (!utils.hasNoValue(vm.display.cutOffTime)) {
                                vm.display.cutOffTime = utils.serverDateStringtoDate(vm.display.cutOffTime);

                                var cutOffHour = vm.display.cutOffTime.getHours();
                                var cutOffMinute = vm.display.cutOffTime.getMinutes();

                                var minsInDay = parseInt(cutOffHour) * 60 + parseInt(cutOffMinute);

                                itemToBeUploaded.availability.cutoffOffsetInMinutes = minsInDay - leadTime;
                            } else {
                                itemToBeUploaded.availability.cutoffOffsetInMinutes = oneDay - 1 - leadTime; // Default
                                // To
                                // 23:59
                            }
                        }
                    } else if (vm.display.menuType == 'realtime') {
                        delete (itemToBeUploaded.availability.orderDays);
                        delete (itemToBeUploaded.availability.blackoutDates);
                        delete (itemToBeUploaded.availability.expiryDateStr);
                    } else { // Recurring
                        var leadTime = utils.hasNoValue(vm.display.leadTime) ? 0 : parseInt(vm.display.leadTime) * 24 * 60;
                        var minsInDay = 0;
                        if (!utils.hasNoValue(vm.display.cutOffTime)) {
                            vm.display.cutOffTime = utils.serverDateStringtoDate(vm.display.cutOffTime);
                            var cutOffHour = vm.display.cutOffTime.getHours();
                            var cutOffMinute = vm.display.cutOffTime.getMinutes();
                            minsInDay = parseInt(cutOffHour) * 60 + parseInt(cutOffMinute);
                        }
                        if (!utils.hasNoValue(vm.display.cutOffTime) || !utils.hasNoValue(vm.display.leadTime)) {
                            itemToBeUploaded.availability.cutoffOffsetInMinutes = minsInDay - leadTime;
                        }

                        if (!vm.holder.itemAlwaysAvailable) {
                            // Set up the list of days
                            const temp = [];
                            for (var i = 0; i < vm.days.length; i++) {
                                if (vm.days[i].selected)
                                    temp.push(vm.days[i].name);
                            }
                            itemToBeUploaded.availability.orderDays = temp.join(',');

                            if (!utils.hasNoValue(vm.display.endDate))
                                itemToBeUploaded.availability.expiryDateStr = utils.dateToServerDateString(vm.display.endDate);

                            // Set up the list of blackoutdates
                            if (!utils.hasNoValue(vm.display.blackoutDateList)) {
                                const transformedBlackoutList = [];
                                for (var i = 0; i < vm.display.blackoutDateList.length; i++) {
                                    const d = utils.dateToServerDateString(vm.display.blackoutDateList[i]);
                                    transformedBlackoutList.push(d);
                                }

                                itemToBeUploaded.availability.blackoutDates = transformedBlackoutList.join(',');
                            }
                            // Otherwise user has deselected all the dates
                            else {
                                itemToBeUploaded.availability.blackoutDates = null;
                            }
                        } else {
                            // Use null rather than deleting
                            itemToBeUploaded.availability.orderDays = null;
                            itemToBeUploaded.availability.blackoutDates = null;
                            itemToBeUploaded.availability.expiryDateStr = null;
                        }
                    }
                }

                // Now blank any items in availability that are the same as the parent
                // Menu
                if (!utils.hasNoValue(vm.currentMenu.availability)) {
                    const menuAv = vm.currentMenu.availability;
                    if (itemToBeUploaded.availability.cutoffOffsetInMinutes === menuAv.cutoffOffsetInMinutes)
                        itemToBeUploaded.availability.cutoffOffsetInMinutes = ''; // Clear
                    // The
                    // Existing
                    // Cutoff

                    if (itemToBeUploaded.availability.expiryDateStr === menuAv.expiryDateStr)
                        itemToBeUploaded.availability.expiryDateStr = null;

                    if (itemToBeUploaded.availability.orderDays === menuAv.orderDays)
                        itemToBeUploaded.availability.orderDays = null;
                } else {
                    delete (itemToBeUploaded.availability);
                }

                if (!utils.hasNoValue(vm.currentTemplate)) {
                    itemToBeUploaded.permissionFormId = vm.currentTemplate.id;
                }
                vm.uploadableProduct = itemToBeUploaded;
            };

            // Callback function from the calendar to find out if a date is disabled
            vm.disabled = function (date, mode) {
                if (mode === 'day' && typeof date !== 'undefined' && (!vm.availableOnDay(date.getDay()))) {
                    return true;
                } else if (mode === 'day' && typeof date !== 'undefined') {
                    // We disable the days that the parent menu has blacked out
                    if (!utils.hasNoValue(vm.currentMenu.availability) && !utils.hasNoValue(vm.currentMenu.availability.blackoutDates)) {
                        const bdlist = vm.currentMenu.availability.blackoutDates;

                        const bdl = bdlist.split(',');
                        for (let i = 0; i < bdl.length; i++) {
                            const d = utils.serverDateToDate(bdl[i]);
                            if (utils.dateToServerDateString(date) === utils.dateToServerDateString(d)) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            };

        vm.availableEveryDay = function () {
            for (let i = 0; i < vm.days.length; i++) {
                if (vm.days[i].selected == false)
                    return false;
            }
            return true;
        };

        vm.availableOnDay = function (dayIndex) {
            const dIndex = ((7 - $rootScope.merchantInfo.contactDetails.country.weekStartingDay) + dayIndex) % 7;
            if (vm.days[dIndex].selected == false)
                return false;

            return true;
        };

        // Initially transform the item - setting any ui variables necessary
        vm.transformForRendering();

        vm.holder.minDate = new Date();
        vm.holder.minExpiryDate = utils.hasNoValue(vm.display.orderEndDate) ? vm.holder.minDate : vm.display.orderEndDate;

        // Set the baseImageUrl using the merchant object in the first product
        vm.$watch('display.orderEndDate', () => {
            if (!utils.hasNoValue(vm.display.orderEndDate)) {
                vm.holder.minExpiryDate = vm.holder.minDate > vm.display.orderEndDate ? vm.holder.minDate : vm.display.orderEndDate;
            }
        }),

            vm.ok = function() {
                vm.saveMenu();
            };

        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.updateNotificationEmailAddresses = function () {
            const emailsToDelete = [];
            const emailsToAdd = [];

            // Determine which email addresses to remove
            $.each(vm.notification.originalEmailAddresses, (index, value) => {
                if ($.inArray(value, vm.notification.shownEmailAddresses) == -1) {
                    emailsToDelete.push(value);
                }
            });

            // Determine which email addresses to add
            $.each(vm.notification.shownEmailAddresses, (index, value) => {
                if ($.inArray(value, vm.notification.originalEmailAddresses) == -1) {
                    emailsToAdd.push(value);
                }
            });

            if(vm.notification.dayOfWeek){
                vm.notificationWeek = vm.daysOfWeek.findIndex(x => x.name === vm.notification.dayOfWeek)+DAY_OF_WEEK_OFFSET;
            }

            const notificationUpdateCommand = {
                emailAddressesAdd: emailsToAdd,
                emailAddressesRemove: emailsToDelete,
                messageType: vm.notification.messageType,
                enabled: vm.notification.enabled,
                sendMinute: vm.notification.minute,
                sendHour: vm.notification.hour,
                sendDayOfWeek : vm.notificationWeek,
                sendDayOfMonth : vm.notification.dayOfMonth
            };

            return notificationUpdateCommand;

            // NotificationService.removeWhenProductSoldNotification(vm.uploadableProduct.id, emailsToDelete)
            // NotificationService.addWhenProductSoldNotification(vm.uploadableProduct.id, emailsToAdd).then(function (promise) {
            //    NotificationService.setEnabledFlagForWhenProductSoldNotification(vm.uploadableProduct.id, vm.notification.enabled, vm.notification.messageType)
            // });
        };

        vm.printer = function() {
            const myStartDate = new Date(vm.display.endDate);
            myStartDate.setMinutes(myStartDate.getMinutes() + vm.currentMenu.availability.cutoffOffsetInMinutes);
        };

        // PERMISSION STUFF
        vm.showPermissionForms = function() {
            vm.permissionFormEnabled = true;
        };

        vm.addPermissionForm = function(permissionTemplate) {
            vm.currentTemplate = permissionTemplate;
        };

        vm.removePermissionForm = function () {
            if (vm.hasSetForm) {
                vm.saving = true;
                menuService.formHasSubmissions(vm.currentTemplate).then((promise) => {
                    vm.saving = false;
                    if (promise.data.value > 0) {
                        const modalInstance = $uibModal.open({
                            template: require('../../templates/common/modalPopup.html'),
                            controller: 'CommonModalPopupController',
                            windowClass: 'fade',
                            backdrop: 'static',
                            resolve: {
                                title() {
                                    return gettextCatalog.getString('Cannot Remove Permission Form');
                                },
                                message() {
                                    return gettextCatalog.getString('Cannot remove permission form. Users have already provided submissions');
                                }
                            }
                        });
                    } else {
                        vm.hasSetForm = false;
                        vm.currentTemplate = null;
                        vm.permissionFormEnabled = false;
                    }
                });
            } else {
                vm.currentTemplate = null;
                vm.permissionFormEnabled = false;
            }
        };

        vm.previewUrl = function() {
            if (vm.currentTemplate) {
                const url = appConfig.serverHost + '/' + appConfig.serverPath + '/form/preview?templateId=' + vm.currentTemplate.id;
                return $sce.trustAsResourceUrl(url);
            } else {
                return null;
            }
        };

        vm.transformForSaving();
        vm.validateForm();

        vm.hideAvailability = function () {
            return merchantService.behaviour(merchantService.merchantInfo, 'editMenuItemPage.hideAvailability');
        };

        vm.hideNotificationSchedule = function () {
            return merchantService.behaviour(merchantService.merchantInfo, 'editMenuItemPage.hideNotificationSchedule');
        };

        vm.hideForms = function () {
            return merchantService.behaviour(merchantService.merchantInfo, 'editMenuItemPage.hideForms');
        };

        vm.showPurchaseTypeOptions = function () {
            return merchantService.behaviour(merchantService.merchantInfo, 'editMenuItemPage.showPurchaseTypeOptions');
        };

        vm.dateOptions = {
            startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
            showWeeks: false
        };

        // Push notification stuff

        vm.sending = false;
        vm.sentToNumUsers = null;
        vm.dateSent = null;
        vm.notificationMessage = '';
        vm.segments = [];

        vm.getSelectedSegmentCount = function() {
            const filtered = _.filter(vm.segments, (segment) => {
                const result = _.find(segment.values, (value) => value.selected);

                return result;
            });

            return filtered.length;
        };

        const initPushNotifications = function () {
            vm.notificationMessage = pushNotificationContext.notificationMessage;
            vm.segments = setupSegments(pushNotificationContext);

            vm.pushNotification = {};
            vm.pushNotification.available = false;
            vm.pushNotification.alreadySent = false;
            vm.pushNotification.enabled = false;

            if (!utils.hasNoValue(pushNotificationContext) && !utils.hasNoValue(pushNotificationContext.availability)) {
                vm.pushNotification.available = pushNotificationContext.availability.available;
                if (pushNotificationContext.availability.alreadySent) {
                    vm.pushNotification.alreadySent = true;
                    vm.pushNotification.enabled = true;
                    vm.sentToNumUsers = pushNotificationContext.availability.numUsers;

                    const dateSent = new Date(pushNotificationContext.availability.dateSent);
                    vm.dateSent = dateSent.format('dd-mmm-yyyy HH:MM');
                }
            }
        };

        vm.save = function () {
            vm.saving = true;
            $uibModalInstance.close('save');
        };

        vm.cancel = function () {
            $uibModalInstance.close('cancel');
        };

        vm.send = function () {
            if (!vm.sending) {
                vm.sending = true;

                // Var departmentId = departmentService.currentDepartmentId;
                const departmentId = departmentService.getCurrentDepId();
                const menuId = menuService.getCurrentMenuId();
                const menuItemId = prod.id;
                const segments = getResponseSegments();
                pushNotificationService.sendProductPushNotification(departmentId, menuId, menuItemId, segments)
                    .then((response) => {
                        vm.pushNotification.alreadySent = true;
                        vm.sentToNumUsers = response.data.value;
                        vm.dateSent = null
                        vm.sending = false;
                        $rootScope.$broadcast('reloadMenuItems', null);
                    }, (response) => {
                        vm.sending = false;
                    });
            }
        };

        vm.isNoSegmentSelected = function() {
            let noSegmentsSelected = true;
            for (let i = 0; i < vm.segments.length; i++) {
                const segment = vm.segments[i];
                const selectedValues = getSelectedValuesInSegment(segment);
                if (selectedValues.length > 0) {
                    noSegmentsSelected = false;
                    break;
                }
            }
            return noSegmentsSelected;
        };

        function setupSegments(pushNotificationContext) {
            const segments = [];
            angular.forEach(pushNotificationContext.segments, (segmentDefinition) => {
                const selectedSegment = getSegmentDefinitionByName(pushNotificationContext, segmentDefinition.name);
                segments.push(createSegment(segmentDefinition, selectedSegment));
            });
            return segments;
        }

        function createSegment(segmentDefinition, selectedSegment) {
            return {
                name: segmentDefinition.name,
                values: createSegmentValues(segmentDefinition, selectedSegment)
            };
        }

        function createSegmentValues(segmentDefinition, selectedSegmentDefinition) {
            const segmentValues = [];
            angular.forEach(segmentDefinition.values, (segmentValueDefinition) => {
                const selected = isSegmentValueSelected(selectedSegmentDefinition, segmentValueDefinition);
                const segmentValue = {
                    name: segmentValueDefinition,
                    selected
                };
                segmentValues.push(segmentValue);
            });
            return segmentValues;
        }

        function isSegmentValueSelected(selectedSegmentDefinition, segmentValueDefinition) {
            if (selectedSegmentDefinition != null) {
                for (let i = 0; i < selectedSegmentDefinition.values.length; i++) {
                    const selectedValue = selectedSegmentDefinition.values[i];
                    if (segmentValueDefinition === selectedValue) {
                        return true;
                    }
                }
            }
            return false;
        }

        function getSegmentDefinitionByName(pushNotificationContext, segmentName) {
            let selectedSegment = null;

            for (let i = 0; i < pushNotificationContext.selectedSegments.length; i++) {
                const currentSelectedSegment = pushNotificationContext.selectedSegments[i];
                if (currentSelectedSegment.name === segmentName) {
                    selectedSegment = currentSelectedSegment;
                    break;
                }
            }
            return selectedSegment;
        }

        function getResponseSegments() {
            const responseSegments = [];
            angular.forEach(vm.segments, (segment) => {
                const selectedValues = getSelectedValuesInSegment(segment);
                if (selectedValues.length > 0) {
                    responseSegments.push(createResponseSegment(segment.name, selectedValues));
                }
            });
            return responseSegments;
        }

        function getSelectedValuesInSegment(segment) {
            const selectedSegmentValues = [];
            angular.forEach(segment.values, (segmentValue) => {
                if (segmentValue.selected) {
                    selectedSegmentValues.push(segmentValue.name);
                }
            });
            return selectedSegmentValues;
        }

        function createResponseSegment(segmentName, selectedValues) {
            const selectedValuesAsArrayOfStringWrappers = utils.convertStringArrayToStringWrapperArray(selectedValues);

            return {
                name: segmentName,
                values: selectedValuesAsArrayOfStringWrappers
            };
        }

        initPushNotifications();
    });



// WEBPACK FOOTER //
// ./src/controllers/modal/menuitem.edit.controller.js